import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get a specific Knowledge Base
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetKnowledge = packet => {
  return {
    type: 'REQUEST_GET_KNOWLEDGE',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetKnowledgeSuccess = data => ({
  type: 'RECEIVE_GET_KNOWLEDGE_SUCCESS',
  data
})

export const receiveGetKnowledgeFail = data => ({
  type: 'RECEIVE_GET_KNOWLEDGE_FAIL',
  data
})

export const tryToGetKnowledge = packet => (dispatch, getState) => {

  dispatch(requestGetKnowledge(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/knowledge/' + packet.id, {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetKnowledgeSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetKnowledgeFail({errors:e, lastSubmit: packet}));
    })
}
